<script setup lang="ts">
import { ref } from 'vue';
import ChartBar from '@primeicons/vue/chart-bar';
import ChevronDown from '@primeicons/vue/chevron-down';
import Card from 'primevue/card';
import Button from 'primevue/button';
import { SHIPMENT_DETAIL_TRIM } from '@/components/shipment/detail/shipment-detail-trim';

const isExpanded = ref(false);

const cardPt = {
  root: {
    class:
      '!rounded-lg !border !border-neutral-200 !bg-white !shadow-none overflow-hidden',
  },
  body: { class: '!p-0' },
  content: { class: '!p-0' },
};
</script>

<template>
  <Card v-if="!SHIPMENT_DETAIL_TRIM.visibilityMetrics" :pt="cardPt">
    <template #content>
      <Button
        type="button"
        text
        class="!flex !w-full !items-center !justify-between !rounded-none !p-4 !text-left"
        @click="isExpanded = !isExpanded"
      >
        <span class="flex items-center gap-2">
          <ChartBar class="text-neutral-400" aria-hidden="true" />
          <span
            class="text-sm font-semibold uppercase tracking-wider text-neutral-900"
          >
            Visibility Metrics
          </span>
        </span>
        <ChevronDown
          class="text-neutral-400 transition-transform"
          :class="{ 'rotate-180': isExpanded }"
          aria-hidden="true"
        />
      </Button>

      <div v-if="isExpanded" class="border-t border-neutral-100 p-4">
        <div class="grid grid-cols-2 gap-4">
          <div
            v-for="label in [
              'On-Time Rate',
              'Avg Dwell Time',
              'Distance Covered',
              'Temp Compliance',
            ]"
            :key="label"
            class="rounded-lg bg-neutral-50 p-3 text-center"
          >
            <div class="text-2xl font-bold text-neutral-900">—</div>
            <div class="mt-1 text-xs text-neutral-500">{{ label }}</div>
          </div>
        </div>
        <p class="mt-3 text-center text-xs text-neutral-400">
          Metrics will be populated when real device data is connected.
        </p>
      </div>
    </template>
  </Card>
</template>
